import { gql } from '@grandvisionhq/graphql';
import { commercialCategoryFragment, frameFeaturesFragment, lensFeaturesFragment } from './fragments/small-fragments.js';
import './fragments/prices/productPriceItem.js';
import './fragments/prices/productPrice.js';
import './fragments/offerings.js';
import { productFragment } from './fragments/product.js';
import { variantFragment } from './fragments/variant.js';

const GET_SUNGLASSES_BY_SLUG = gql`
  query GetSunglassesBySlug($slug: String!, $facets: [SearchFacetInput!]!) {
    getProductBySlug(slug: $slug, facets: $facets) {
      product {
        __typename
        ... on SunglassesProduct {
          id
          ...productFragment
          commercialCategories {
            ...CommercialCategoryFragment
          }
          productTypeDetails {
            isOfferedWithPrescriptions
            isExclusiveBrand
          }
          variants {
            ...variantFragment
            variantTypeDetails {
              channelAvailability
              recommendedCategoryKey
              brandModelCode
              brandModelColorCode
              targetGender
              targetGenderAllLocales {
                value
                locale
              }
              isReservable
              isVtoEnabled
              trend
              frameFeatures {
                ...frameFeaturesFragment
              }
              lensFeatures {
                ...lensFeaturesFragment
              }
              faceShape {
                shape
              }
              segment
              roadworthiness
            }
          }
        }
      }
    }
  }
  ${productFragment}
  ${commercialCategoryFragment}
  ${variantFragment}
  ${frameFeaturesFragment}
  ${lensFeaturesFragment}
`;

export { GET_SUNGLASSES_BY_SLUG };
//# sourceMappingURL=get-sunglasses-by-slug.js.map
